import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

function useDesktop(mediaQuery, size) {
	const theme = useTheme();
	let defaultMediaQuery = mediaQuery || theme.breakpoints.up('sm');

	// if two params were given
	if(mediaQuery && size) {
		if(mediaQuery === 'up') {
			defaultMediaQuery = theme.breakpoints.up(size);
		} else {
			defaultMediaQuery = theme.breakpoints.down(size);
		}
	};

	const isDesktop = useMediaQuery(defaultMediaQuery);
	return isDesktop;
}

export default useDesktop;
